import SvgAccountTree from '../../../../assets/icons/AccountTree';
import SvgAdd from '../../../../assets/icons/Add';
import SvgAnalytics from '../../../../assets/icons/Analytics';
import SvgApartment from '../../../../assets/icons/Apartment';
import SvgAssignment from '../../../../assets/icons/Assignment';
import SvgBarChart from '../../../../assets/icons/BarChart';
import SvgCall from '../../../../assets/icons/Call';
import SvgCampaign from '../../../../assets/icons/Campaign';
import SvgCloud from '../../../../assets/icons/Cloud';
import SvgCode from '../../../../assets/icons/Code';
import SvgContract from '../../../../assets/icons/Contract';
import SvgDashboard from '../../../../assets/icons/Dashboard';
import SvgDashboardCustomize from '../../../../assets/icons/DashboardCustomize';
import SvgDelete from '../../../../assets/icons/Delete';
import SvgDescription from '../../../../assets/icons/Description';
import SvgDesignServices from '../../../../assets/icons/DesignServices';
import SvgDone from '../../../../assets/icons/Done';
import SvgDownload from '../../../../assets/icons/Download';
import SvgEdit from '../../../../assets/icons/Edit';
import SvgEditNote from '../../../../assets/icons/EditNote';
import SvgEvent from '../../../../assets/icons/Event';
import SvgExtension from '../../../../assets/icons/Extension';
import SvgFindInPage from '../../../../assets/icons/FindInPage';
import SvgFlight from '../../../../assets/icons/Flight';
import SvgFolder from '../../../../assets/icons/Folder';
import SvgFolderOpen from '../../../../assets/icons/FolderOpen';
import SvgGavel from '../../../../assets/icons/Gavel';
import SvgGridView from '../../../../assets/icons/GridView';
import SvgGroup from '../../../../assets/icons/Group';
import SvgHelp from '../../../../assets/icons/Help';
import SvgHome from '../../../../assets/icons/Home';
import SvgHub from '../../../../assets/icons/Hub';
import SvgInstantMix from '../../../../assets/icons/InstantMix';
import SvgLiveHelp from '../../../../assets/icons/LiveHelp';
import SvgLocalShipping from '../../../../assets/icons/LocalShipping';
import SvgManageAccounts from '../../../../assets/icons/ManageAccounts';
import SvgMenu from '../../../../assets/icons/Menu';
import SvgMenuOpen from '../../../../assets/icons/MenuOpen';
import SvgNote from '../../../../assets/icons/Note';
import SvgNoteAdd from '../../../../assets/icons/NoteAdd';
import SvgPageview from '../../../../assets/icons/Pageview';
import SvgPanaroma from '../../../../assets/icons/Panaroma';
import SvgPeople from '../../../../assets/icons/People';
import SvgPerson from '../../../../assets/icons/Person';
import SvgPersonAddAlt from '../../../../assets/icons/PersonAddAlt';
import SvgPrint from '../../../../assets/icons/Print';
import SvgPublic from '../../../../assets/icons/Public';
import SvgRecordVoiceOver from '../../../../assets/icons/RecordVoiceOver';
import SvgRefresh from '../../../../assets/icons/Refresh';
import SvgReport from '../../../../assets/icons/Report';
import SvgRule from '../../../../assets/icons/Rule';
import SvgSailing from '../../../../assets/icons/Sailing';
import SvgSchedule from '../../../../assets/icons/Schedule';
import SvgSearch from '../../../../assets/icons/Search';
import SvgSettings from '../../../../assets/icons/Settings';
import SvgShare from '../../../../assets/icons/Share';
import SvgShoppingBag from '../../../../assets/icons/ShoppingBag';
import SvgShoppingBasket from '../../../../assets/icons/ShoppingBasket';
import SvgShoppingCart from '../../../../assets/icons/ShoppingCart';
import SvgStorefront from '../../../../assets/icons/Storefront';
import SvgSummarize from '../../../../assets/icons/Summarize';
import SvgSupportAgent from '../../../../assets/icons/SupportAgent';
import SvgTableView from '../../../../assets/icons/TableView';
import SvgTask from '../../../../assets/icons/Task';
import SvgTaskAlt from '../../../../assets/icons/TaskAlt';
import SvgTextSnippet from '../../../../assets/icons/TextSnippet';
import SvgVerified from '../../../../assets/icons/Verified';
import SvgVerifiedUser from '../../../../assets/icons/VerifiedUser';
import SvgWidgets from '../../../../assets/icons/Widgets';
import SvgWorkspacePremium from '../../../../assets/icons/WorkspacePremium';
import SvgWorkspaces from '../../../../assets/icons/Workspaces';

export const tileIcons = {
    add: <SvgAdd />,
    assignment: <SvgAssignment />,
    panaroma: <SvgPanaroma />,
    contract: <SvgContract />,
    edit: <SvgEdit />,
    group: <SvgGroup />,
    settings: <SvgSettings />,
    task: <SvgTask />,
    verifiedUser: <SvgVerifiedUser />,
    verified: <SvgVerified />,
    event: <SvgEvent />,
    extension: <SvgExtension />,
    note: <SvgNote />,
    noteAdd: <SvgNoteAdd />,
    done: <SvgDone />,
    person: <SvgPerson />,
    rule: <SvgRule />,
    gavel: <SvgGavel />,
    call: <SvgCall />,
    localShipping: <SvgLocalShipping />,
    flight: <SvgFlight />,
    sailing: <SvgSailing />,
    dashboard: <SvgDashboard />,
    dashboardCustomize: <SvgDashboardCustomize />,
    analytics: <SvgAnalytics />,
    barChart: <SvgBarChart />,
    designServices: <SvgDesignServices />,
    description: <SvgDescription />,
    textSnippet: <SvgTextSnippet />,
    tableView: <SvgTableView />,
    editNote: <SvgEditNote />,
    assignment: <SvgAssignment />,
    storefront: <SvgStorefront />,
    apartment: <SvgApartment />,
    shoppingBag: <SvgShoppingBag />,
    help: <SvgHelp />,
    liveHelp: <SvgLiveHelp />,
    folder: <SvgFolder />,
    folderOpen: <SvgFolderOpen />,
    gridView: <SvgGridView />,
    code: <SvgCode />,
    findInPage: <SvgFindInPage />,
    pageView: <SvgPageview />,
    search: <SvgSearch />,
    taskAlt: <SvgTaskAlt />,
    home: <SvgHome />,
    menu: <SvgMenu />,
    menuOpen: <SvgMenuOpen />,
    widgets: <SvgWidgets />,
    cloud: <SvgCloud />,
    print: <SvgPrint />,
    public: <SvgPublic />,
    hub: <SvgHub />,
    workspacePremium: <SvgWorkspacePremium />,
    workspaces: <SvgWorkspaces />,
    people: <SvgPeople />,
    report: <SvgReport />,
    summarize: <SvgSummarize />,
    delete: <SvgDelete />,
    schedule: <SvgSchedule />,
    share: <SvgShare />,
    campaign: <SvgCampaign />,
    recordVoiceOver: <SvgRecordVoiceOver />,
    download: <SvgDownload />,
    manageAccounts: <SvgManageAccounts />,
    shoppingBasket: <SvgShoppingBasket />,
    shoppingCart: <SvgShoppingCart />,
    supportAgent: <SvgSupportAgent />,
    accountTree: <SvgAccountTree />,
    instantMix: <SvgInstantMix />,
    refresh: <SvgRefresh />,
    addPerson: <SvgPersonAddAlt />,
};

export const tileIconTypes = {
    add: SvgAdd,
    assignment: SvgAssignment,
    panaroma: SvgPanaroma,
    contract: SvgContract,
    edit: SvgEdit,
    group: SvgGroup,
    settings: SvgSettings,
    task: SvgTask,
    verifiedUser: SvgVerifiedUser,
    verified: SvgVerified,
    event: SvgEvent,
    extension: SvgExtension,
    note: SvgNote,
    noteAdd: SvgNoteAdd,
    done: SvgDone,
    person: SvgPerson,
    rule: SvgRule,
    gavel: SvgGavel,
    call: SvgCall,
    localShipping: SvgLocalShipping,
    flight: SvgFlight,
    sailing: SvgSailing,
    dashboard: SvgDashboard,
    dashboardCustomize: SvgDashboardCustomize,
    analytics: SvgAnalytics,
    barChart: SvgBarChart,
    designServices: SvgDesignServices,
    description: SvgDescription,
    textSnippet: SvgTextSnippet,
    tableView: SvgTableView,
    editNote: SvgEditNote,
    assignment: SvgAssignment,
    storefront: SvgStorefront,
    apartment: SvgApartment,
    shoppingBag: SvgShoppingBag,
    help: SvgHelp,
    liveHelp: SvgLiveHelp,
    folder: SvgFolder,
    folderOpen: SvgFolderOpen,
    gridView: SvgGridView,
    code: SvgCode,
    findInPage: SvgFindInPage,
    pageView: SvgPageview,
    search: SvgSearch,
    taskAlt: SvgTaskAlt,
    home: SvgHome,
    menu: SvgMenu,
    menuOpen: SvgMenuOpen,
    widgets: SvgWidgets,
    cloud: SvgCloud,
    print: SvgPrint,
    public: SvgPublic,
    hub: SvgHub,
    workspacePremium: SvgWorkspacePremium,
    workspaces: SvgWorkspaces,
    people: SvgPeople,
    report: SvgReport,
    summarize: SvgSummarize,
    delete: SvgDelete,
    schedule: SvgSchedule,
    share: SvgShare,
    campaign: SvgCampaign,
    recordVoiceOver: SvgRecordVoiceOver,
    download: SvgDownload,
    manageAccounts: SvgManageAccounts,
    shoppingBasket: SvgShoppingBasket,
    shoppingCart: SvgShoppingCart,
    supportAgent: SvgSupportAgent,
    accountTree: SvgAccountTree,
    instantMix: SvgInstantMix,
    refresh: SvgRefresh,
};
